import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.85, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ num, eyebrow, title, text, align = "left" }) => (
    <div className={align === "center" ? "text-center" : ""} data-testid={`section-heading-${num}`}>
        <Reveal>
            <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
                <span className="font-mono text-xs text-amber-400/80">{num}</span>
                <span className="h-px w-10 bg-amber-400/40" />
                <span className="eyebrow">{eyebrow}</span>
            </div>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="mt-5 font-display font-wide text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
                {title}
            </h2>
        </Reveal>
        {text && (
            <Reveal delay={0.16}>
                <p className={`mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg ${align === "center" ? "mx-auto" : ""}`}>
                    {text}
                </p>
            </Reveal>
        )}
    </div>
);
